import { extendObservable, computed, action } from "mobx";
import { RouterStore } from "mobx-react-router";
import QuestionableCallsContainer from "../containers/QuestionableCallsContainer";
import StrikeZoneContainer from "../containers/StrikeZoneContainer";
import StrikeZoneChartContainer from "../containers/StrikeZoneChartContainer";
import GroundTruthContainer from "../containers/GroundTruthContainer";
import ModelBasedAlertingContainer from "../containers/ModelBasedAlertingContainer";

class SetiRouterStore extends RouterStore {
  constructor() {
    super();

    extendObservable(this, {
      referrer: null,
      pages: [
        {
          path: "/",
          label: "Strike Zone Table",
          isActive: computed(() => this.isStrikeZoneTableTab),
          component: StrikeZoneContainer,
          isExact: true
        },
        {
          path: "/strike-zone-chart",
          label: "Strike Zone Chart",
          isActive: computed(() => this.isStrikeZoneChartTab),
          component: StrikeZoneChartContainer
        },
        {
          path: "/questionable-calls",
          label: "Questionable Calls",
          isActive: computed(() => this.isQuestionableCallsTab),
          component: QuestionableCallsContainer
        },
        {
          path: "/ground-truth",
          label: "Ground Truth",
          isActive: computed(() => this.isGroundTruthTab),
          component: GroundTruthContainer
        },
        {
          path: "/model-based-alerting",
          label: "Model Based Alerting",
          isActive: computed(() => this.isModelBasedAlertingTab),
          component: ModelBasedAlertingContainer
        }
      ],
      setReferrer: action(() => {
        this.referrer = `${this.location.pathname}${this.location.search}`;
      }),
      goToReferrer: action(() => {
        this.replace(this.referrer);
        this.referrer = null;
      }),
      isStrikeZoneTableTab: computed(() => this.location.pathname === "/"),
      isStrikeZoneChartTab: computed(
        () => this.location.pathname === "/strike-zone-chart"
      ),
      isQuestionableCallsTab: computed(
        () => this.location.pathname === "/questionable-calls"
      ),
      isGroundTruthTab: computed(
        () => this.location.pathname === "/ground-truth"
      ),
      isModelBasedAlertingTab: computed(
        () => this.location.pathname === "/model-based-alerting"
      ),
      isTrackmanAccuracyReportTab: computed(
        () => this.location.pathname === "/data-quality-report"
      )
    });
  }
}

export default SetiRouterStore;



// WEBPACK FOOTER //
// ./src/stores/setiRouterStore.js